export default function Footer() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading text-background-50 mb-3 block">99漫画</span>
            <p className="text-xs text-background-400 leading-relaxed">
              推荐类似4399漫画网的免费好看漫画平台，专注韩漫、日漫、国漫全集大全，提供下拉式阅读与追更收藏体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">快速导航</h4>
            <div className="space-y-2">
              {[
                { href: '#hero', label: '首页' },
                { href: '#index', label: '专题合集' },
                { href: '#updates', label: '更新快讯' },
                { href: '#features', label: '平台优势' },
                { href: '#ranking', label: '人气榜单' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleScrollTo(e, link.href)}
                  className="block text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">内容分类</h4>
            <div className="space-y-2">
              <span className="block text-xs text-background-400">韩漫推荐</span>
              <span className="block text-xs text-background-400">日漫连载</span>
              <span className="block text-xs text-background-400">国漫精选</span>
              <span className="block text-xs text-background-400">完结全集</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">联系我们</h4>
            <div className="space-y-2">
              <span className="block text-xs text-background-400">
                <i className="ri-mail-line mr-1.5"></i>contact@99manhua.com
              </span>
              <span className="block text-xs text-background-400">
                <i className="ri-wechat-line mr-1.5"></i>99漫画官方
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/40 pt-8 mb-8">
          <h4 className="text-sm font-semibold text-background-300 mb-4 text-center">合作伙伴</h4>
          <div className="flex flex-wrap items-center justify-center gap-6">
            <span className="text-xs text-background-500">优质漫画平台联盟</span>
            <span className="text-xs text-background-500">内容合作方入驻</span>
            <span className="text-xs text-background-500">广告合作咨询</span>
            <span className="text-xs text-background-500">版权合作对接</span>
          </div>
        </div>

        <div className="border-t border-background-700/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 99漫画 - 推荐类似4399漫画网的免费好看漫画平台。本站所有漫画资源均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">使用条款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}